'use client'

import Heading from '@/components/Heading/Heading'
import ContextualHelpModal from '@/components/Help/ContextualHelpModal'
import ProductListView from './ProductListView'
import { useCallback, useMemo, useState } from 'react'
import LaserProfilePage from '@/components/LaserProfile/LaserProfilePage'
import HatchProfilePage from '@/components/HatchProfile/HatchProfilePage'
import PricingPage from '@/components/Pricing/Components/PricingPage'
import ShapeProfilePage from '@/components/ShapeProfile/ShapeProfilePage'
import ViewProfilePage from '@/components/ViewProfile/ViewProfilePage'
import StepToGlbConverter from '@/components/StepToGlb/StepToGlbConverter'
import { useSnapshot } from 'valtio'
import store from '@/store'

const allTabs = [
  { name: 'Profiles', component: () => <ProductListView /> },
  { name: 'Shape Profiles', component: () => <ShapeProfilePage />, neatolabsOnly: true },
  { name: 'View Profiles', component: () => <ViewProfilePage /> },
  { name: 'Laser Profiles', component: () => <LaserProfilePage />, neatolabsOnly: true },
  { name: 'Hatch Profiles', component: () => <HatchProfilePage />, neatolabsOnly: true },
  { name: 'Pricing', component: () => <PricingPage /> },
  { name: '3D Studio', component: () => <StepToGlbConverter /> },
]

export default function Home() {
  const [selectedTab, setSelectedTab] = useState(0)
  const [isHelpOpen, setIsHelpOpen] = useState(false)
  const { companySetting } = useSnapshot(store)

  const filteredTabs = useMemo(() => {
    const isNeatolabs = companySetting.machine === 'neatolabs'
    return allTabs.filter((tab) => !tab.neatolabsOnly || isNeatolabs)
  }, [companySetting.machine])

  const tabs = useMemo(() => filteredTabs.map(({ name }) => ({ name })), [filteredTabs])

  const handleOnSelectedTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const getCurrentTabContent = useCallback(() => {
    const tab = filteredTabs[selectedTab]
    return tab ? tab.component() : <ProductListView />
  }, [selectedTab, filteredTabs])

  return (
    <div className="flex w-full bg-white gap-md min-h-full">
      <div className="flex-grow flex flex-col">
        <Heading
          title={'Products'}
          description={
            'Manage and sync products, including single items, bundles, and product profiles, for laser engraving settings.'
          }
          help={{
            title: 'Help',
            onClick: () => setIsHelpOpen(true),
          }}
          tab={{
            onSelectedChange: handleOnSelectedTabChange,
            selectedTab: selectedTab,
            tabs: tabs,
          }}
        />
        <div className={'pr-xxl flex flex-col flex-grow'}>{getCurrentTabContent()}</div>
      </div>
      <ContextualHelpModal categoryId="products" isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </div>
  )
}
